import { type ReactElement } from 'react';
import { useSearchParams } from 'react-router';
import { googleSignInUrl, magicLinkCallbackUrl } from '@/lib/api';
import { useAuthMethods } from '@/hooks/use-auth-methods';
import { LanguageToggle } from '@/components/language-toggle';
import { useTranslation } from '@/lib/i18n';
import { Button } from '@/components/ui/button';

// Both paths carry the same invite: Google must match it, the link already is it.
export function JoinPage(): ReactElement {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const { googleEnabled, magicLinkEnabled } = useAuthMethods();
  const token = params.get('token');

  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-6 p-6 px-safe pt-safe pb-safe">
      <div className="absolute top-3 right-3 mt-safe">
        <LanguageToggle />
      </div>
      <div className="text-center">
        <h1 className="text-xl font-bold tracking-tight">{t('joinTitle')}</h1>
        <p className="mt-1 max-w-xs text-sm text-muted-foreground">
          {token === null ? t('joinMissing') : t('joinLead')}
        </p>
      </div>
      {token !== null && !googleEnabled && !magicLinkEnabled && (
        <p
          role="alert"
          className="max-w-xs rounded-lg bg-amber-100 px-3 py-2 text-center text-sm text-amber-900"
        >
          {t('noSignInMethod')}
        </p>
      )}
      {token !== null && (
        <div className="flex w-full max-w-xs flex-col gap-3">
          {googleEnabled && (
            <Button asChild className="w-full">
              <a href={googleSignInUrl(token)}>{t('continueGoogle')}</a>
            </Button>
          )}
          {magicLinkEnabled && (
            <Button asChild variant={googleEnabled ? 'outline' : 'default'} className="w-full">
              <a href={magicLinkCallbackUrl(token)}>{t('joinWithLink')}</a>
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
